import { useLang } from "../i18n/LanguageContext";

export default function Marquee() {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee];
  return (
    <div
      className="relative overflow-hidden border-y border-sand/30 bg-espresso py-4"
      aria-hidden="true"
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee-x items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="whitespace-nowrap font-serif italic text-lg text-cream/90">{item}</span>
            <svg className="mx-8 h-2.5 w-2.5 text-terracotta" viewBox="0 0 10 10" fill="currentColor" aria-hidden="true">
              <path d="M5 0 L10 5 L5 10 L0 5 Z" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}
